/**
 * Controller: GroupsRemoveModal
 */
angular.module('acme.view.application.groups.removeModal.controllers', [])
.controller('GroupsRemoveModalController', [ '$scope', '$uibModalInstance', 'currentGroup', function ($scope, $uibModalInstance, currentGroup) {

    $scope.errors = [];

    $scope.model = {
      id: currentGroup.id,
      name: currentGroup.name,
      displayName: currentGroup.displayName
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);